<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasSupplier="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :items="payments"
      :pagination="pagination"
      :columns="columns"
      :nameProperty="nameProperty"
      :reportTypes="reportTypes"
      :getTrigger="getTrigger"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      payments: [],
      pagination: {},
      reportTypes: ["statistic", "simple", "detail"],
      reportType: "statistic",
      nameProperty: "PaymentNumber",
      getTrigger: false,
    };
  },
  computed: {
    columns() {
      if (this.reportType == "statistic") {
        let s = [
          { name: "SupplierNumber" },
          { name: "SupplierName" },
          { name: "Payable" },
          { name: "FreePrice" },
          { name: "Total" },
          { name: "YTaxPrice" },
          { name: "TaxPrice" },
          { name: "NoPay" },
          { name: "Payed" },
        ];
        return s;
      } else if (this.reportType == "simple") {
        let s = [
          { name: "TradeType" },
          { name: "PurchaseNumber" },
          { name: "PurchaseDate" },
          { name: "AccountDate" },
          { name: "SupplierNumber" },
          { name: "SupplierName" },
          { name: "Payable" },
          { name: "FreePrice" },
          { name: "Total" },
          { name: "Payed" },
          { name: "NoPay" },
        ];
        return s;
      } else if (this.reportType == "detail") {
        let s = [
          { name: "PurchaseDate" },
          { name: "PurchaseNumber" },
          { name: "TradeType" },
          { name: "AccountDate" },
          { name: "SupplierNumber" },
          { name: "SupplierName" },
          { name: "AllTotal" },
          { name: "Payed" },
          { name: "NoPay" },
          { name: "FoodNumber" },
          { name: "FoodName" },
          { name: "Qty" },
          { name: "Cost" },
          { name: "Total" },
        ];
        return s;
      }
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    getItems(condition) {
      const vm = this;
      this.reportType = condition.ReportType;
      this.$api.payables.getPages(condition).then((data) => {
        vm.payments = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
    downloadExcel(condition) {
      this.$api.reportExcels.getPayable(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getPayable(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printPayable(condition);
    },
  },
};
</script>
